//ContactUs.Router.js
define('ContactUs.Router'
,   [   
      'ContactUs.View'
   ,  'Backbone'
	]
,   function (
      ContactUsView
   ,  Backbone
   )
{
   'use strict';

   //@class Address.Router @extend Backbone.Router
   return Backbone.Router.extend({

      routes: {
			'contact-us': 'ContactUsRouter'
      }

   ,   initialize: function (application)
      {
         this.application = application;
      }

      // list myNewRouter output
	,   ContactUsRouter: function ()
		{
           var view = new ContactUsView({
              application: this.application
           })
           view.showContent();
        }
   });
});
